<template>
    <g id="pagos_oxi" :class="oxi_class" v-on:mouseenter="startAnimation" v-tooltip="{ content: etching_press, classes: 'oxi_tooltip' }">
      <g id="sh_oxi_overlay" data-name="sh oxi overlay">
        <g class="cls-21">
          <g class="cls-64">
            <use transform="matrix(-0.03, -0.02, 0.3, -0.02, 832.17, 701.77)" xlink:href="#image-2"/>
          </g>
        </g>
      </g>
      <g id="oxi_back_part">
        <g>
          <rect class="cls-24" x="883" y="460.7" width="371.8" height="31.35"/>
          <polygon class="cls-65" points="1254.9 460.9 883 460.9 887.6 455.2 1262.7 455.2 1254.9 460.9"/>
          <polygon class="cls-66" points="1262.7 455.2 1254.9 461.1 1254.9 492 1262.7 485.4 1262.7 455.2"/>
        </g>
        <polyline class="cls-67" points="829.3 587.6 895.3 552.5 895.3 575.8 829.3 611.3"/>
        <g>
          <rect class="cls-24" x="892.7" y="550.1" width="325.4" height="10.59"/>
          <rect class="cls-8" x="892.7" y="552.2" width="325.4" height="26.85"/>
        </g>
        <g>
          <polyline class="cls-24" points="895.1 655 900.2 652.1 908.5 636.8 903.2 637.4"/>
          <polygon class="cls-24" points="904.2 639.7 908.4 636.9 908.4 485.3 904.2 485.3 904.2 639.7"/>
          <polygon class="cls-68" points="885.1 655.2 895.1 655.2 904.2 639.8 885.1 639.8 885.1 655.2"/>
          <circle class="cls-24" cx="893.7" cy="638.1" r="4.6"/>
        </g>
        <g>
          <polyline class="cls-24" points="895.1 655 900.2 652.2 908.5 637.2 903.2 637.8"/>
          <polygon class="cls-24" points="904.2 640.1 908.4 636.8 908.4 467.3 904.2 467.3 904.2 640.1"/>
          <rect class="cls-8" x="885.1" y="491" width="19.1" height="149.26"/>
          <polygon class="cls-8" points="885.1 655.2 895.1 655.2 904.2 640.2 885.1 640.2 885.1 655.2"/>
        </g>
        <g>
          <polygon class="cls-24" points="1235.3 643.8 1231.1 646.5 1231.1 476.6 1235.3 476.6 1235.3 643.8"/>
          <rect class="cls-8" x="1212.1" y="492.1" width="19.1" height="139.19"/>
          <polygon class="cls-8" points="1231.2 646.5 1221.2 646.5 1212.1 631.2 1231.2 629.6 1231.2 646.5"/>
        </g>
        <polyline class="cls-67" points="1181.5 594.1 1232 559 1232 580.1 1181.5 617.8"/>
        <polygon class="cls-24" points="1033.9 372.7 1013.9 374.1 1013.9 461.5 1033.9 461 1033.9 372.7"/>
        <polygon class="cls-69" points="1037.7 374.2 1033.8 374.2 1033.8 461.1 1037.7 458 1037.7 374.2"/>
        <rect class="cls-24" x="1057.2" y="373.7" width="19.7" height="87.58"/>
        <polygon class="cls-69" points="1080.8 372.7 1076.8 374.2 1076.8 461.2 1080.9 457.5 1080.8 372.7"/>
        <polygon class="cls-24" points="1067.6 357.7 1023 357.7 1013.9 374.1 1076.7 374.1 1067.6 357.7"/>
        <polygon class="cls-65" points="1067.6 357.7 1076.8 374.3 1080.9 372.7 1070.8 355.9 1067.6 357.7"/>
        <polygon class="cls-69" points="1023 357.7 1067.6 357.7 1070.8 355.9 1026.2 355.9 1023 357.7"/>
        <g id="oxi_hadle2">
          <rect class="cls-65" x="1027" y="334.9" width="37.9" height="4.46"/>
          <circle cx="1019.3" cy="336.6" r="8.9"/>
          <circle class="cls-69" cx="1016.4" cy="332.6" r="2.4"/>
          <circle cx="1068.1" cy="336.6" r="8.9"/>
          <rect class="cls-24" x="1041.8" y="340.8" width="4.2" height="17.94"/>
          <circle class="cls-69" cx="1064.5" cy="332.5" r="2.4"/>
          <path class="cls-69" d="M1048.7,332.5c0,.2,0,.3,0,.5A5,5,0,0,0,1048.7,332.5Z"/>
          <rect class="cls-70" x="1038.4" y="329.8" width="10.8" height="14.88" rx="4.3" ry="4.3"/>
          <path class="cls-71" d="M1049.2,334.3c0,1-1.9,1.8-4.3,1.8h-2.2c-2.4,0-4.3-.8-4.3-1.8v-2.7c0-1,1.9-1.8,4.3-1.8h2.2c2.4,0,4.3.8,4.3,1.8Z"/>
          <path class="cls-72" d="M1049.2,331.8c0,.5-1.9.8-4.3.8h-2.2c-2.4,0-4.3-.4-4.3-.8v-1.2c0-.5,1.9-.8,4.3-.8h2.2c2.4,0,4.3.4,4.3.8Z"/>
        </g>
      </g>
      <g id="oxi_surface">
        <path class="cls-66" d="M807.5,505.8a4,4,0,0,1,.1-.8,4.8,4.8,0,0,1,.3-.8,3.5,3.5,0,0,1,1.1-1.5l.5-.3h.8a1.2,1.2,0,0,1,1,1c.1.4-.3.8-.5,1.1a2.9,2.9,0,0,1-.9.9,5.4,5.4,0,0,1-1.1.7l-.6.2h0"/>
        <g>
          <polygon class="cls-73" points="1252.2 465.9 877.4 465.4 809.4 503.7 1188.1 503.7 1206.4 493 1188.1 503.8 809.7 503.8 809.7 523.9 1188.1 523.9 1252.3 486.2 1252.3 466.2 1252.2 465.9"/>
          <path class="cls-74" d="M1187.8,506.6a5.6,5.6,0,0,1,2.5-4.3l59.6-34.8c1.4-.8,2.5-.2,2.5,1.4v14.4a5.7,5.7,0,0,1-2.5,4.4l-59.6,36c-1.4.8-2.5.2-2.5-1.4Z"/>
          <path class="cls-75" d="M1249.7,467.4c1.4-.8,1.2-1.5-.4-1.5l-371-.5a13.1,13.1,0,0,0-5.4,1.4l-63.4,35.5c-1.4.8-1.2,1.4.4,1.4h375a12.6,12.6,0,0,0,5.4-1.5Z"/>
          <rect class="cls-66" x="807.3" y="503.8" width="380.4" height="20.18" rx="2.9" ry="2.9"/>
        </g>
      </g>
      <g id="copper_plate" data-name="copper plate">
        <g>
          <g>
            <g class="cls-76" clip-path="url(#clip-path-21)">
              <image width="1284" height="1024" transform="translate(1116.8 461.4) scale(0.07 0.04)" xlink:href="../../assets/img/textures/copper_plate.png"/> 
            </g>
            <polyline class="cls-77" points="1169.2 485.9 1169.5 486.5 1201.2 468.2 1201.2 467.4"/>
            <rect class="cls-78" x="1122.2" y="485.8" width="47.3" height="0.74"/>
          </g>
          <polygon class="cls-79" points="1147.5 471.3 1161.9 485.7 1151.8 485.7 1141.3 474.8 1147.5 471.3"/>
          <polyline class="cls-80" points="1165.2 468 1177.9 477.3 1180.4 479.2 1186.4 475.8 1175.4 467.2"/>
        </g>
      </g>
      <g id="oxi_paper">
        <path class="cls-81" d="M1185.6,468.2h-.1a9.3,9.3,0,0,1-1.7,1c-.2.1-.4.2-.1.2s.1,0,0,.1h-.4l-.8.6-.4.3-.9.5a9.6,9.6,0,0,1-2,1.1c-.5.2-.7.4-.6.5l-.2.2h-.1l-.9.6-2.1,1.2c-.9.5-1.4,1.1-2.4,1.6l-1.6.9h-2a1.2,1.2,0,0,1-.9,0h-5c-.4-.3-1.7-.1-2.8-.1h-8.2a11.1,11.1,0,0,0-1.7,0c-.9,0-2.2.1-2.9,0h-25.1c-.6,0-1.3.1-1.2-.2l2.5-1.4.3-.2a4.3,4.3,0,0,1,1.7-1l1.1-.6.9-.5a5.2,5.2,0,0,0,1.5-1.1,7,7,0,0,1,1.5-1l1.5-.8c.2-.1.2-.2.2-.3l.9-.5,2.4-1.4,2-1.3.7-.4a5,5,0,0,0,1.6-1,14.9,14.9,0,0,1,2.6-1.4l2.4-1.4a23.2,23.2,0,0,1,2.4-1.7l3.3-1.9,1.9-1.1.7-.2a26.3,26.3,0,0,1,2.7,0h10.9l2.6.2h.6a10.8,10.8,0,0,1,2.3,0h3.2a12.7,12.7,0,0,1,2.8-.1h18.3c1.1.1,2.7-.2,3.7-.1s.1.1.2.1.2,0,.1.1a10.4,10.4,0,0,1-1.4,1.1l-2.7,1.7-2.4,1.5-2.5,1.7-2.7,1.6a14.2,14.2,0,0,0-1.9,1.2,2.5,2.5,0,0,1-1,.6,4.5,4.5,0,0,0-1.1.6Z"/>
      </g>
      <g id="oxi_cloth">
        <g>
          <g>
            <path class="cls-82" d="M1123.6,462.4h49.3c1.1-.1,8.9-3.8,13.1-6.7s17.4-9.8,17.4-9.8,1.8-.2,1.6-2.9.5-3.2-1.7-3.6-41.4,0-43.3,0-4.9,1.9-4.9,1.9a55.1,55.1,0,0,1-5,2.7l-7.6,3.8-8.2,4-6.8,3.4a20.6,20.6,0,0,0-3.4,1.8c-.4.3-.8,1-.4,1.5s.5.1.8.2h.8c.2.2.1.6,0,.8s-1,.4-1.4.6a1.7,1.7,0,0,0-.7,1C1123,461.6,1123.4,462.4,1123.6,462.4Z"/>
            <path class="cls-83" d="M1123.6,462.4a4.7,4.7,0,0,0,1.3,0h48c1.1-.1,8.9-3.8,13.1-6.7s17.4-9.8,17.4-9.8,1.8-.2,1.6-2.9.6-2.5-1.6-2.8a4.6,4.6,0,0,0-2.1.7c-3.2,1.4-6.2,3.2-9.2,4.9l-7,4.1-6.6,3.7a32.5,32.5,0,0,1-3.3,1.6,14.1,14.1,0,0,1-2.7.5l-.9.2h-2.2a79.9,79.9,0,0,1-12.8,1h-6.7c-2.8.2-5.6.2-8.4.2h-16.6a.8.8,0,0,0-.7.4c-.3.5,0,.6.4.9a1.6,1.6,0,0,1,.4.6c0,.1-.2.4-.2.6s0,.4-.2.6l-.6.6a3.8,3.8,0,0,0-.6.9C1123.1,462,1123.3,462.3,1123.6,462.4Z"/>
            <path class="cls-84" d="M1123.6,462.4h46.6c1.3,0,3.4.4,3.9-1.2a9.1,9.1,0,0,0,.6-1.9,3.1,3.1,0,0,0-.3-2.1l-.5-.4-.3-.3-.6-.2-.5-.4-.9-.2h-2.3a79.9,79.9,0,0,1-12.8,1h-6.7c-3.6.3-7.2.2-10.8.2h-14.3l-.6.2c-.3.1-.8.1-1,.4s-.1.9-.1,1.4h1a2.8,2.8,0,0,0,.8.3,2.9,2.9,0,0,1-1.1.4c-.3.1-.6.3-.9.3s-.1,2.1.6,2.3Z"/>
            <path class="cls-85" d="M1172.1,459.5a1.2,1.2,0,0,1-1.3,1.2h-45.2l-2.2-.3c0-.3.5-.4.7-.6s.7-.3.3-.6l-.4-.2-.3-.2c-.2-.1-.6,0-.7-.2h38.6a27,27,0,0,0,4.6-.2l2-.5h1.5c1.1.1,2.2.4,2.4,1.7A1.6,1.6,0,0,1,1172.1,459.5Z"/>
            <path class="cls-86" d="M1205,440.7c-.1-.8-.4-1.1-1.7-1.3s-41.4,0-43.3,0-4.9,1.9-4.9,1.9a55.1,55.1,0,0,1-5,2.7l-7.6,3.8-8.2,4-6.8,3.4a20.6,20.6,0,0,0-3.4,1.8h-.1a1.5,1.5,0,0,0-.8.4c-.3.4-.1.9-.1,1.4h1.5l.2.2-.9.3c-.3.1-.6.3-.9.3s-.1,2.1.6,2.3h49.4c1.1-.1,8.9-3.8,13.1-6.7s17.4-9.8,17.4-9.8,1.8-.2,1.6-2.9S1205.1,441,1205,440.7Z"/>
          </g>
          <g class="cls-21">
            <g class="cls-87">
              <use transform="matrix(0.02, 0.02, -0.04, 0.03, 1196.2, 419.76)" xlink:href="#image-2"/>
            </g>
          </g>
          <g class="cls-88">
            <g class="cls-87">
              <use transform="matrix(0.01, 0.01, -0.04, 0.03, 1209.59, 426.53)" xlink:href="#image-2"/>
            </g>
          </g>
        </g>
      </g>
      <g id="oxi_cylinder">
        <g>
          <g>
            <circle class="cls-19" cx="1042.3" cy="438.6" r="28.8"/>
            <polygon class="cls-19" points="988.9 446.5 1024 416.4 1061.8 459.5 1026.1 490.8 988.9 446.5"/>
            <circle class="cls-89" cx="1008.6" cy="467.5" r="29.2"/>
            <circle class="cls-16" cx="1008.6" cy="467.5" r="10"/>
            <circle cx="1008.6" cy="467.5" r="5.1"/>
          </g>
          <g class="cls-21">
            <g class="cls-90">
              <use transform="matrix(0.09, -0.08, 0.11, 0.14, 907.91, 505.89)" xlink:href="#image-2"/>
            </g>
          </g>
        </g>
      </g>
      <g id="oxi_front_part">
        <rect class="cls-66" x="832.3" y="590.8" width="338.6" height="9.57"/>
        <g>
          <polyline class="cls-24" points="838.6 687.8 843.7 685 852 669.6 846.7 670.2"/>
          <polygon class="cls-24" points="847.7 672.5 851.9 669.7 851.9 518.1 847.7 518.1 847.7 672.5"/>
          <rect class="cls-68" x="828.5" y="518.1" width="19.1" height="154.68"/>
          <polygon class="cls-68" points="828.5 688 838.6 688 847.7 672.6 828.5 672.6 828.5 688"/>
          <circle class="cls-24" cx="837.2" cy="671" r="4.6"/>
        </g>
        <g>
          <polyline class="cls-66" points="838.6 687.8 843.7 685 852 669.6 846.7 670.2"/>
          <polygon class="cls-66" points="847.7 672.5 851.9 669.7 851.9 518.1 847.7 518.1 847.7 672.5"/>
          <rect class="cls-24" x="828.5" y="518.1" width="19.1" height="154.68"/>
          <polygon class="cls-24" points="828.5 688 838.6 688 847.7 672.6 828.5 672.6 828.5 688"/>
          <circle class="cls-24" cx="837.2" cy="671" r="4.6"/>
        </g>
        <polygon class="cls-66" points="1181.6 685.3 1177.3 687.9 1177.3 518.1 1181.6 518.1 1181.6 685.3"/>
        <rect class="cls-24" x="1158.3" y="518.1" width="19.1" height="154.68"/>
        <polygon class="cls-24" points="1177.5 688 1167.4 688 1158.3 672.6 1177.5 672.6 1177.5 688"/>
        <circle class="cls-24" cx="1168.8" cy="671" r="4.6"/>
        <rect class="cls-24" x="832.3" y="594.4" width="338.6" height="25.06"/>
        <g>
          <rect class="cls-24" x="821.1" y="495.6" width="371.8" height="31.35"/>
          <polygon class="cls-65" points="1193 495.8 821.1 495.8 825.7 490.1 1200.7 490.1 1193 495.8"/>
          <polygon class="cls-66" points="1200.7 490.1 1193 496 1193 526.9 1200.7 520.3 1200.7 490.1"/>
        </g>
        <rect class="cls-24" x="977.4" y="410" width="20.5" height="86.17"/>
        <polygon class="cls-69" points="1001.2 410.6 997.4 410.6 997.4 496.2 1001.2 492.6 1001.2 410.6"/>
        <polygon class="cls-24" points="1040.4 410.1 1020.7 410.1 1020.7 497.4 1040.4 495.9 1040.4 410.1"/>
        <polygon class="cls-69" points="1044.4 409.2 1040.3 410.6 1040.3 495.9 1044.5 492.5 1044.4 409.2"/>
        <polygon class="cls-24" points="1031.2 394.1 986.5 394.1 977.4 410.6 1040.3 410.6 1031.2 394.1"/>
        <polygon class="cls-65" points="1031.2 394.1 1040.4 410.8 1044.4 409.2 1034.4 392.3 1031.2 394.1"/>
        <polygon class="cls-69" points="986.5 394.1 1031.2 394.1 1034.4 392.3 989.7 392.3 986.5 394.1"/>
        <g id="oxi_hadle">
          <rect class="cls-65" x="988.7" y="372" width="37.9" height="4.46"/>
          <circle cx="981" cy="373.7" r="8.9"/>
          <circle class="cls-69" cx="978.1" cy="369.7" r="2.4"/>
          <circle cx="1029.8" cy="373.7" r="8.9"/>
          <rect class="cls-24" x="1003.5" y="377.9" width="4.2" height="17.94"/>
          <circle class="cls-69" cx="1026.2" cy="369.6" r="2.4"/>
          <path class="cls-69" d="M1010.5,369.6c0,.2,0,.3,0,.5A4.8,4.8,0,0,0,1010.5,369.6Z"/>
          <rect class="cls-70" x="1000.1" y="366.9" width="10.8" height="14.88" rx="4.3" ry="4.3"/>
          <path class="cls-71" d="M1010.9,371.4c0,1-1.9,1.8-4.3,1.8h-2.2c-2.4,0-4.3-.8-4.3-1.8v-2.7c0-1,1.9-1.8,4.3-1.8h2.2c2.4,0,4.3.8,4.3,1.8Z"/>
          <path class="cls-72" d="M1010.9,368.9c0,.5-1.9.8-4.3.8h-2.2c-2.4,0-4.3-.4-4.3-.8v-1.2c0-.5,1.9-.8,4.3-.8h2.2c2.4,0,4.3.4,4.3.8Z"/>
        </g>
      </g>
      <g id="wheel">
        <g>
          <path d="M1035.3,431a91.5,91.5,0,1,0,62.7,113.1A91.5,91.5,0,0,0,1035.3,431ZM987.5,597.8a82.1,82.1,0,1,1,101.6-56.3A82.1,82.1,0,0,1,987.5,597.8Z"/>
          <circle class="cls-19" cx="1010.2" cy="518.7" r="25.3" transform="translate(233.1 1346.7) rotate(-74)"/>
          <circle cx="1013.0" cy="514.7" r="21.4" transform="matrix(0.28, -0.96, 0.96, 0.28, 233.1, 1346.7)"/>
          <polyline class="cls-91" points="927.3 540 1010.2 519.2 1090.4 495.8"/>
          <polyline class="cls-91" points="951.8 458.2 1011.2 522.4 1067.5 580"/>
          <polyline class="cls-91" points="1032.3 439 1010.1 519.1 989.3 601"/>
          <circle class="cls-73" cx="1010.1" cy="518.7" r="11.6" transform="translate(232.9 1346.6) rotate(-74)"/>
          <circle class="cls-24" cx="1010.1" cy="518.7" r="7.6" transform="translate(233 1346.7) rotate(-74)"/>
          <circle cx="1010.1" cy="518.7" r="1" transform="translate(233 1346.7) rotate(-74)"/>
          <path class="cls-92" d="M1033.3,437a85.3,85.3,0,1,0,58.5,105.6A85.3,85.3,0,0,0,1033.3,437Zm-46,160.3A81.4,81.4,0,1,1,1088,541.5,81.4,81.4,0,0,1,987.4,597.3Z"/>
        </g>
      </g>
    </g>	
</template>

<script>
export default {
	name: 'pagos_oxi',
	data () {
		return {
			oxi_class: "myclass",
      etching_press: "πρέσα οξυγραφίας"
		}
	},
	methods: { 
		startAnimation: function(){ 
			if(this.oxi_class != 'playanimation') {
				this.oxi_class = 'playanimation';
				setTimeout( () => { 
					this.oxi_class = '';
			 	}, 6000)
			}
		}

	},
	mounted: function () {

	}
}	
</script>


// WEBPACK FOOTER //
// PagosOxi.vue?34f3b2bf